import NotificationType from '../NotificationType';
import { batchDocumentRoute } from './batchDocumentRoute';

export default class ReimbursementCoverSheetGenerated extends NotificationType {
  get icon() {
    return 'fa-solid fa-file-invoice-dollar';
  }

  resolveRoute(notification) {
    return batchDocumentRoute(notification);
  }
}
